import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';

export const handleSelectByVersion = createAction(types.SELECT_BY_VERSION);
export const clearSelectByVersion = createAction(types.CLEAR_SELECT_BY_VERSION);
export const cleanupTestSummary = createAction(types.CLEANUP_TEST_SUMMARY);
